<template>
    <main class="app-container">
        <section class="profile loader-block-parent">
            <div v-show="isLoading" class="loader-block">
                <div>
                    <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
                </div>
            </div>
            <div class="profile__top">
                <h2>{{ $t('projects.list.my_projects') }}</h2>
                <div class="my-projects__options">
                    <button class="btn-add" v-if="isArchitect" data-a11y-dialog-show="add-dialog">
                        <img src="@/assets/icons/admin/add.svg" width="24" height="24" :alt="$t('projects.list.add_project')" />{{ $t('projects.list.add_project') }}
                    </button>
                    <button v-if="type != 's' && type != 'xs'">
                        <img src="@/assets/icons/sorts.svg" width="24" height="24" :alt="$t('projects.list.sort')" />{{ $t('projects.list.sort') }}
                        <div class="list">
                            <div class="list__inner">
                                <ul>
                                    <li v-for="sortType in sortTypes"
                                        @click.prevent="sortProjects(sortType)"
                                        :class="{'selected': selectedSortType === sortType}"
                                    >
                                        {{ $t('projects.sort_list.' + sortType) }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </button>
                    <button v-else @click.prevent="showSortList = !showSortList"
                            ref="clickOutsideSort">
                        <img src="@/assets/icons/sorts.svg" width="24" height="24" :alt="$t('projects.list.sort')" />{{ $t('projects.list.sort') }}
                        <div v-if="showSortList" class="list">
                            <div v-if="showSortList" class="list__inner">
                                <ul>
                                    <li v-for="sortType in sortTypes"
                                        @click="sortProjects(sortType)"
                                        :class="{'selected': selectedSortType === sortType}"
                                    >
                                        {{ $t('projects.sort_list.' + sortType) }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </button>
                    <button v-if="type != 's' && type != 'xs'">
                        <img src="@/assets/icons/filter.svg" width="15.913" height="16" :alt="$t('projects.list.filter')" />{{ $t('projects.list.filter') }}
                        <div class="list">
                            <div class="list__inner">
                                <ul>
                                    <li v-for="filterType in filterTypes"
                                        @click.prevent="filterProjects(filterType)"
                                        :class="{'selected': selectedFilterType === filterType}"
                                    >
                                        {{ $t('projects.filter_list.' + filterType) }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </button>
                    <button v-else @click.prevent="showFilterList = !showFilterList"
                            ref="clickOutsideFilter">
                        <img src="@/assets/icons/filter.svg" width="15.913" height="16" :alt="$t('projects.list.filter')" />{{ $t('projects.list.filter') }}
                        <div v-if="showFilterList" class="list">
                            <div v-if="showFilterList" class="list__inner">
                                <ul>
                                    <li v-for="filterType in filterTypes"
                                        @click.prevent="filterProjects(filterType)"
                                        :class="{'selected': selectedFilterType === filterType}"
                                    >
                                        {{ $t('projects.filter_list.' + filterType) }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </button>
                </div>
            </div>
            <div class="my-projects">
                <router-link  v-for="project in projects" :to="{name: 'project-details', params: {id: project.id, activeTab: 'shoppingList'}}">
                    <div :class="{ 'project': true, 'project-disabled': project.status === ProjectStatus.FINISHED }">
                        <div class="project__header">
                            <div class="project__menu">
                                <p class="project__name">{{ project.name }}</p>
                                <div v-if="type != 's' && type != 'xs'" class="project__menu-options">
                                    <span></span><span></span><span></span>
                                    <div class="project__menu-list">
                                        <ul>
                                            <li>
                                                <router-link :to="{name: 'project-details', params: {id: project.id, activeTab: 'shoppingList'}}">{{ $t('projects.list.edit') }}</router-link>
                                            </li>
                                            <li>
                                                <router-link :to="{name: 'project-settings', params: {id: project.id}}">{{ $t('projects.list.settings') }}</router-link>
                                            </li>
                                            <li v-if="isArchitect" @click.prevent="showDeleteProjectDialog(project)">{{ $t('projects.list.delete') }}</li>
                                            <li v-if="isArchitect" @click.prevent="openFileBox(project.id)">{{ $t('projects.list.change_image') }}</li>
                                        </ul>
                                    </div>
                                </div>
                                <div v-if="type == 's' || type == 'xs'" class="project__menu-options" @click.prevent="toggleActiveProjectMenu(project.id)">
                                    <span></span><span></span><span></span>
                                    <div v-show="activeProjectMenu == project.id" class="project__menu-list">
                                        <ul>
                                            <li>
                                                <router-link :to="{name: 'project-details', params: {id: project.id, activeTab: 'shoppingList'}}">{{ $t('projects.list.edit') }}</router-link>
                                            </li>
                                            <li>
                                                <router-link :to="{name: 'project-settings', params: {id: project.id}}">{{ $t('projects.list.settings') }}</router-link>
                                            </li>
                                            <li v-if="isArchitect" @click.prevent="showDeleteProjectDialog(project)">{{ $t('projects.list.delete') }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="project__user-list">
                                <div class="project__user">
                                    <user-image
                                    :src="project.imagePath"
                                    :user="{
                                        firstName: project.firstName,
                                        lastName: project.lastName,
                                    }"
                                    alt="Zdjęcie użytkownika"
                                    width="28"
                                    height="28"
                                    />
                                    <span>{{ [project.firstName, project.lastName].join(' ') }}</span>
                                </div>
                            </div>
                        </div>
                        <div
                        class="project__image"
                        :style=getProjectDummyImage(project)
                        >
                            <div class="project__image--upload" >
                                <button @click.once.prevent="openFileBox(project.id)" v-show="project.images.length <= 0 && !project.isLoading">
                                    <svg
                                        width="60"
                                        height="54"
                                        viewBox="0 0 60 54"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M48.666 16.3333V10.9999H43.3327V5.66658H48.666V0.333252H53.9994V5.66658H59.3327V10.9999H53.9994V16.3333H48.666ZM5.99935 53.6666C4.53268 53.6666 3.27757 53.1448 2.23402 52.1012C1.18868 51.0559 0.666016 49.7999 0.666016 48.3332V16.3333C0.666016 14.8666 1.18868 13.6115 2.23402 12.5679C3.27757 11.5226 4.53268 10.9999 5.99935 10.9999H14.3993L19.3327 5.66658H35.3327V10.9999H21.666L16.7994 16.3333H5.99935V48.3332H48.666V24.3333H53.9994V48.3332C53.9994 49.7999 53.4776 51.0559 52.434 52.1012C51.3887 53.1448 50.1327 53.6666 48.666 53.6666H5.99935ZM27.3327 44.3332C30.666 44.3332 33.4998 43.167 35.834 40.8346C38.1665 38.5004 39.3327 35.6666 39.3327 32.3333C39.3327 28.9999 38.1665 26.1661 35.834 23.8319C33.4998 21.4995 30.666 20.3333 27.3327 20.3333C23.9993 20.3333 21.1656 21.4995 18.8313 23.8319C16.4989 26.1661 15.3327 28.9999 15.3327 32.3333C15.3327 35.6666 16.4989 38.5004 18.8313 40.8346C21.1656 43.167 23.9993 44.3332 27.3327 44.3332ZM27.3327 38.9999C25.466 38.9999 23.8882 38.3555 22.5993 37.0666C21.3105 35.7777 20.666 34.1999 20.666 32.3333C20.666 30.4666 21.3105 28.8888 22.5993 27.5999C23.8882 26.311 25.466 25.6666 27.3327 25.6666C29.1994 25.6666 30.7771 26.311 32.066 27.5999C33.3549 28.8888 33.9994 30.4666 33.9994 32.3333C33.9994 34.1999 33.3549 35.7777 32.066 37.0666C30.7771 38.3555 29.1994 38.9999 27.3327 38.9999Z"
                                            fill="darkgrey"
                                        />
                                    </svg>
                                </button>
                                <div v-if="project.isLoading" class="lds-ring"><div></div><div></div><div></div><div></div></div>
                                <input hidden @click="openDialogFile" type="file" @input="uploadImage(project)" accept="image/*" :id="'projectImage-'+project.id"  />
                            </div>
                        </div>
                        <div class="project__bottom">
                            <span class="project__status" v-if="project.status">{{ $t('projects.status.' + project.status.toLowerCase() ) }}</span>
                            <div>
                                <img src="@/assets/icons/schedule.svg" width="18.9" height="18.9" alt="Ikona zegara" />
                                <template v-if="project.status === ProjectStatus.FINISHED">
                                    {{ $t('projects.list.end_project') }}:&nbsp<span class="project__deadline">{{ formatDate(project.deadline) }}</span>
                                </template>
                                <template v-else>
                                    {{ $t('projects.list.deadline') }}:&nbsp<span class="project__deadline">{{ formatDate(project.deadline) }}</span>
                                </template>
                            </div>
                        </div>
                    </div>
                </router-link>
            </div>
        </section>
    </main>
        <template v-if="isArchitect">
            <add-project-modal />
            <delete-project-modal ref="deleteProjectModal" />
        </template>
</template>

<script>
import UserLayout from "@/layouts/UserLayout";
import AddProjectModal from "@/components/architect/AddProjectModal";
import {storeToRefs} from "pinia";
import {inject, ref} from "vue";
import {useProjectsStore} from "@/stores/user/projects.store";
import router from "@/router";
import moment from "moment";
import DeleteProjectModal from "@/components/architect/deleteProjectModal";
import {useAuthStore} from "@/stores/auth.store";
import {Role} from "@/helpsers/role.helper";
import {ProjectStatus} from "@/helpsers/project.helper";
import UserImage from "@/components/image/UserImage.vue";
import breakpointsHelper from "@/helpsers/breakpoints.helper";
import {useClickOutside} from "@/helpsers/click-outside.helpers";
import AlertHelper from "@/helpsers/alert.helper";
import ApiHelper from "@/helpsers/api.helper";
import axios from "axios";
import authHelper from "@/helpsers/auth.helper";

export default {
    name: "ProjectsList",
    components: {DeleteProjectModal, AddProjectModal, UserLayout, UserImage},
    setup() {
        const userStore = useAuthStore();
        const projectStore = useProjectsStore();
        let { projects, page, onPage, total, isLoading, sortTypes, filterTypes, selectedSortType, selectedFilterType } = storeToRefs(projectStore);
        let showSortList = ref(false);
        let showFilterList = ref(false);
        const deleteProjectModal = ref();
        const emitter = inject('emitter');
        const isArchitect = userStore.user.role == Role.Architect;
        const projectsImages = ref([]);
        //Pobieranie rozmiaru ekranu.
        const { width, type } = breakpointsHelper();
        const activeProjectMenu = ref(null);
        const alert = inject('alert');

        let queryParams = router.currentRoute.value.query;
        if (queryParams) {
            for (let paramName in queryParams) {
               if (paramName === 'order' && selectedSortType.value !== queryParams[paramName])
                    selectedSortType.value = queryParams[paramName];
                if (paramName === 'filter' && selectedFilterType.value !== queryParams[paramName])
                    selectedFilterType.value = queryParams[paramName];
            }
        }
        projectStore.fetchProjects();
        projectStore.fetchSortTypes();
        projectStore.fetchFilterTypes();

        function setCurrentQueryParamsString() {
            let params = '';
            if (selectedSortType.value) {
                if (params)
                    params += '&';
                params += `order=${encodeURIComponent(selectedSortType.value)}`
            }
            if (selectedFilterType.value) {
                if (params)
                    params += '&';
                params += `filter=${encodeURIComponent(selectedFilterType.value)}`
            }

            return params;
        }

        emitter.on('projectDeleted', () => {
            refreshProjectsList();
        })

        function refreshProjectsList() {
            let params = setCurrentQueryParamsString();
            if (params)
                history.pushState({}, null, `${router?.currentRoute?.value?.path}?${params}`);
            projectStore.fetchProjects();
        }

        function sortProjects(type) {
            if (type === selectedSortType.value)
                selectedSortType.value = null;
            else
                selectedSortType.value = type;
            refreshProjectsList();
        }

        function filterProjects(type) {
            if (type === selectedFilterType.value)
                selectedFilterType.value = null;
            else
                selectedFilterType.value = type;
            refreshProjectsList();
        }

        const clickOutsideSort = ref('');
        useClickOutside(clickOutsideSort,(e) => {
            showSortList.value = false;
        });

        const clickOutsideFilter = ref('');
        useClickOutside(clickOutsideFilter,(e) => {
            showFilterList.value = false;
        });

        function formatDate(date = null) {
            return date ? moment(date).format('DD.MM.YYYY'): '';
        }

        function showDeleteProjectDialog(projectData) {
            deleteProjectModal.value.showModal(projectData)
        }

        function getProjectDummyImage(project) {
            if(project.images.length > 0)
                return `background-image: url(${project.images[0].imagePath})`;

            return `background-image: none`;
        }

        function checkCanAddImage(event, project) {
            if(project.images.length <= 0) {
                event.stopPropagation();
                event.preventDefault();
            }
        }

        function openDialogFile(event) {
            console.log(event);
            event.stopPropagation();
        }

        async function uploadImage(project) {
            project.isLoading = true;

            const photo = document.querySelector(`#projectImage-${project.id}`).files[0];
            const formData = new FormData();
            let deletedImage = true;

            formData.append("files", photo);
            formData.append('projectId',project.id);
            formData.append('type','PROJECT');

            if(project.images.length > 0) {
                try {
                    deletedImage = await axios.delete(ApiHelper.getDeleteImageFromProjectUrl(project.id, project.images[0].id), {
                        headers: authHelper.authHeader()
                    });
                    project.images = [];
                }
                catch (error) {
                    project.isLoading = true;
                    let errorMessage = ApiHelper.getResponseMessage(error.response?.data?.code);
                    AlertHelper.show(alert, errorMessage, '', 'error');
                }


            }

            if(deletedImage)
            {
                axios.post(ApiHelper.getAddImageToProjectUrl(project.id), formData, {
                    headers: authHelper.authHeader()
                })
                    .then(result => {
                        project.isLoading = false;
                        project.images.push(...result.data);
                    })
                    .catch(error => {
                        let errorMessage = ApiHelper.getResponseMessage(error.response?.data?.code);
                        AlertHelper.show(alert, errorMessage, '', 'error');
                        project.isLoading = false;
                        console.log('Nie zmieniono zdjęcia', error);
                    })
            }
        }

        function toggleActiveProjectMenu(projectId) {
            activeProjectMenu.value = activeProjectMenu.value == projectId ? null : projectId;
        }

        function openFileBox(projectId) {
            document.querySelector(`#projectImage-${projectId}`).click();
        }

        return {
            projects,
            page,
            onPage,
            total,
            isLoading,
            sortTypes,
            sortProjects,
            filterProjects,
            clickOutsideSort,
            clickOutsideFilter,
            filterTypes,
            showSortList,
            showFilterList,
            selectedSortType,
            selectedFilterType,
            formatDate,
            showDeleteProjectDialog,
            deleteProjectModal,
            isArchitect,
            ProjectStatus,
            getProjectDummyImage,
            type,
            activeProjectMenu,
            toggleActiveProjectMenu,
            openDialogFile,
            uploadImage,
            openFileBox,
        }
    }
}
</script>

<style scoped lang="scss">
.my-projects {
    &__options {
        button {
            z-index: 1;

            &:hover {
                transform: scale(1.05);
                cursor: pointer;
            }
            &.btn-add {
                background: #DEE9EA;
                border-radius: 6px;
                border: 1px solid #49838866;
                color: #498388;
                font: normal normal 500 1.5rem/16px Montserrat;
                padding: 5px 15px;
                img {
                    /* One way to change svg fill color using img tag */
                    /* to #498388 */
                    filter: invert(46%) sepia(58%) saturate(301%) hue-rotate(136deg) brightness(90%) contrast(86%);
                }

                &:hover {
                    background: #3B767B;
                    color: #FFFFFF;
                    img {
                        filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7488%) hue-rotate(296deg) brightness(104%) contrast(99%);
                    }
                }
            }
        }

        .list {
            li {
                &:hover {
                    color: #ff7366;
                }
                &.selected {
                    color: #ff7366;
                    background-color: #f5e4e3;
                }
            }
        }
    }
}

.project {
    margin-bottom: 30px;

    &__menu {
        &>div {
            cursor: pointer;
            width: 15px;
            &:hover span {
                cursor: pointer;
                background: #ff7366;
            }
        }
        span {
            cursor: default;
            &:hover {

            }
        }
    }
    &__bottom {
        cursor: default;
    }
    &__menu-list {
        ul {
            li {
                color: #000;
                &:hover {
                    color: #ff7366;
                    a {
                        color: #ff7366;
                    }
                }
                a {
                    color: #353535;
                    &:hover {
                        color: #ff7366;
                    }
                }

                a {
                    color: #353535;
                    &:hover {
                        color: #ff7366;
                    }
                }
            }
        }
    }

    &__image {
        &--upload {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;

            button {
                background: none;
                border: none;
                cursor: pointer;

                path {
                    fill: #cacaca;
                }
                &:hover {
                    path {
                        fill: #8c8f94;
                    }
                }
            }

            .lds-ring {
                div {
                    border-color: #fe796d transparent transparent transparent;
                }
            }

                input[type="file"] {
                    color: transparent;
                    &::-webkit-file-upload-button {
                        visibility: hidden;
                    }
                    &::before {
                        content: 'Wybierz zdjęcie';
                        color: white;
                        display: block;
                        background: #ff7366;
                        border-radius: 3px;
                        padding: 5px 8px;
                        outline: none;
                        white-space: nowrap;
                        -webkit-user-select: none;
                        cursor: pointer;
                        font-weight: 700;
                        font-size: 10pt;
                        text-align: center;
                    }
                }
        }

    }
}
</style>
